import { TFunction } from 'i18next';
import {
	ISurveyTrackingDetail,
	SurveyTrackingDetails,
} from 'modules/admin-panel/pages/settings/models';

const DASH_SYMBOLS = '—';

export const getTotalResponseRate = (sent?: number, completed?: number) => {
	if (!sent || !completed) return 0;
	return Math.floor((completed / sent) * 100);
};

export const getTotalValue = (
	col: SurveyTrackingDetails,
	data: ISurveyTrackingDetail[],
	totalReminders: number | undefined,
	t: TFunction,
) => {
	switch (col) {
		case SurveyTrackingDetails.city:
			return t('total');
		case SurveyTrackingDetails.sentReminders:
			return totalReminders || 0;
		case SurveyTrackingDetails.responseRate:
			return '';
		case SurveyTrackingDetails.sendingDateTime:
			return DASH_SYMBOLS;
		default:
			return data.reduce(
				(result: number, rowData) => result + ((rowData[col] as number) || 0),
				0,
			);
	}
};
